export default __webpack_public_path__ + "static/media/rh-lg.b076e739.png";